<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">EMPRESAS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoEmpresa = true" tile color="#3BA8A2">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-btn color="#94AAB4" @click="carregaDados">Recarregar</v-btn>
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <p style="margin: 0px">
              <v-icon :color="item.situacao == 'ATIVO' ? 'success' : 'error'">mdi-circle</v-icon>
            </p>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoEmpresa" persistent max-width="900px" scrollable>
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text style="padding-bottom: 0px; padding-top: 10px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="9" lg="9">
              <v-text-field label="Nome*" outlined dense hide-details v-model="editedItem.nome"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="3">
              <v-text-field label="CNPJ*" v-mask="'##.###.###/####-##'" outlined dense hide-details v-model="editedItem.cnpj"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="4">
              <v-text-field label="Endereço*" outlined dense hide-details v-model="editedItem.endereco"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="4">
              <v-text-field label="Telefone*" v-mask="'(##) #####-####'" outlined dense hide-details v-model="editedItem.telefone"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="4">
              <v-text-field label="E-mail" outlined dense hide-details v-model="editedItem.email"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-select label="Situação" outlined dense hide-details v-model="editedItem.situacao" :items="situacoes" item-text="text" item-value="value"></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-select label="Segmento" outlined dense hide-details v-model="editedItem.segmento" :items="segmentos" item-text="text" item-value="value"></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-select label="Plano" outlined dense hide-details v-model="editedItem.planoId" :items="planos" item-text="nome" item-value="id"></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="4">
              <v-text-field label="Canal WebSocket" outlined dense hide-details v-model="editedItem.canalWS"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="4">
              <v-text-field label="Token WhatsApp" outlined dense hide-details v-model="editedItem.tokenWhatsApp"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="4">
              <v-text-field label="Api WhatsApp" outlined dense hide-details v-model="editedItem.apiWhatsApp"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="4">
              <v-text-field label="Zapi ClientToken" outlined dense hide-details v-model="editedItem.zapiClientToken"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="4">
              <v-text-field label="Zapi InstanciaID" outlined dense hide-details v-model="editedItem.zapiInstanciaID"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="4">
              <v-text-field label="Zapi InstanciaToken" outlined dense hide-details v-model="editedItem.zapiInstanciaToken"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="4">
              <v-text-field label="Tempo MaximoAula" outlined dense hide-details v-model="editedItem.tempoMaximoAula"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="4">
              <v-text-field label="Tempo MinimoPesquisa" outlined dense hide-details v-model="editedItem.tempoMinimoPesquisa"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="3">
             <v-switch inset v-model="editedItem.enviarMsgAvaliacao" label="Envio WhatsApp"></v-switch>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" v-if="editedItem.enviarMsgAvaliacao">
              <v-textarea label="Mensagem Avaliacao" outlined hide-details v-model="editedItem.msgAvaliacao" ></v-textarea>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="Logo URL*" outlined dense hide-details v-model="editedItem.logoUrl"></v-text-field>
              <v-img contain :src="editedItem.logoUrl" height="100" width="100%" v-if="editedItem.logoUrl" style="max-width: 100%; max-width: 130px; margin-top: 10px" class="mx-auto"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoEmpresa = false">Fechar</v-btn>
          <v-btn text color="success" @click="salvarEmpresa">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'CNPJ', value: 'cnpj' },
          { text: 'Telefone', value: 'telefone' },
          { text: 'Situação', value: 'situacao' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        conteudo: [],
      },
      dialogoEmpresa: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        cnpj: '',
        endereco: '',
        telefone: '',
        logoUrl: '',
        email: '',
        situacao: '',
        segmento: '',
        planoId: '',
        canalWS: '',
        collectionId: '',
        apiWhatsApp: '',
        tokenWhatsApp: '',
        zapiClientToken: '',
        zapiInstanciaID: '',
        zapiInstanciaToken: '',
        enviarMsgAvaliacao: true,
        msgAvaliacao: '',
        tempoMaximoAula: '',
        tempoMinimoPesquisa: '',
      },
      defaultItem: {
        nome: '',
        cnpj: '',
        endereco: '',
        telefone: '',
        logoUrl: '',
        email: '',
        situacao: '',
        segmento: '',
        planoId: '',
        canalWS: '',
        collectionId: '',
        apiWhatsApp: '',
        tokenWhatsApp: '',
        zapiClientToken: '',
        zapiInstanciaID: '',
        zapiInstanciaToken: '',
        enviarMsgAvaliacao: true,
        msgAvaliacao: '',
        tempoMaximoAula: '',
        tempoMinimoPesquisa: '',
      },
      situacoes: [
        { text: 'Ativo', value: 'ATIVO' },
        { text: 'Inativo', value: 'INATIVO' },
      ],
      segmentos: [
        { text: 'Studio', value: 'STUDIO' },
      ],
      planos: [],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar nova empresa' : 'Editar empresa'
      },
    }),

    watch: {
      dialogoEmpresa(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      }
    },

    mounted() {
      this.carregaDados()
      this.carregaPlanos()
    },

    methods: {
      async carregaDados () {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudo = response.data
            this.isLoading = false
          }
        })
      },

      async carregaPlanos () {
        await axios.get(baseApiUrl + 'Planos?filter={"order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.planos = response.data
          }
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoEmpresa = true
        this.isLoading = false
      },

      async salvarEmpresa() {
        var vm = this;
        if (this.editedItem.nome || this.editedItem.cnpj || this.editedItem.endereco || this.editedItem.telefone || this.editedItem.logoUrl || this.editedItem.avatarUrl) {
          this.isLoading = true
          await axios.post(baseApiUrl + 'Empresas/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoEmpresa = false
              if (this.editedIndex == -1)
                this.criaColecao(response.data.id)
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaDados()
            }           	
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("F9A825", "Preencha os campos para prosseguir", "ATENÇÃO")
        }
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR o cliente ' + item.nome + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Empresas/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {    
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaDados()
          })
        }
      },

      async criaColecao(id) {
        await axios.post(baseApiUrl + 'Faces/criarColecao', { "empresaId": id })
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
  
  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>